import React, { useState, useEffect } from 'react';

const itemOptions = [
    "Strawberry Lemon Cream Croissant", "Strawberry Croissant", "Fruit Pastry", "Mini Strawberry Pastry",
    "Mini Blueberry Pastry", "Pastry Frank", "King Cream Donut", "Almond Pastry", "Sugar Mochi Donut",
    "Coffee Croissant Donut", "Coffee Danish", "4 Cheese Quiche", "Feuillete au Chocolat", "Croissant Donut",
    "Sweet Potato Pastry", "Coffee Bun", "Pastel De Nata", "Pain aux Raisins", "Quiche Lorraine",
    "Chocolate Croissant", "Very Berry Pastry", "Smoked Sausage Bread", "Raspberry Almond Croissant",
    "Valentine's Chocolate Covered Strawberry King Cream Donut", "Sweet Rice Donut",
    "Butter Pecan Supreme Croissant", "Butter Pecan King Cream Donut", "Chausson Aux Pommes",
    "Tiramisu Tart", "Blueberry Cream Cheese Pastry", "Pineapple Brulee Pastry", "Pepperoni Pizzetta",
    "Jumbo Twisted Donut", "Cherry & Greek Yogurt Danish", "Mini Garlic Croissant (6pcs)",
    "Mini Grain Cream Cheese Pastry (6pcs)", "Blueberry & Cream Brioche", "20oz Signature Brewed Coffee",
    "Hash Brown Bread", "20oz Vanilla Latte", "Sausage Stick Bread", "Twisted Donut",
    "Mango & Cream Brioche", "16oz Chai Latte"
];

const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const Prediction = () => {
    const [itemName, setItemName] = useState('');
    const [predictionResult, setPredictionResult] = useState(null);
    const [error, setError] = useState('');

    const [highWasteItems, setHighWasteItems] = useState([]);

    // New state for multi-day prediction
    const [multiPrediction, setMultiPrediction] = useState([]);
    const [selectedItem, setSelectedItem] = useState(itemOptions[0]);
    const [selectedDays, setSelectedDays] = useState(5);
    const [startDay, setStartDay] = useState('Monday');

    useEffect(() => {
        fetchHighWasteItems();
    }, []);

    const fetchHighWasteItems = async () => {
        try {
            const response = await fetch('https://ai.ninjabakers.com/predict_high_waste_items');
            if (!response.ok) {
                const errData = await response.json();
                setError(errData.error || 'Failed to fetch high waste items');
                return;
            }
            const data = await response.json();
            setHighWasteItems(data.top_waste_items_predictions || []);
        } catch (err) {
            setError('Error calling the high-waste API');
            console.error(err);
        }
    };

    const handlePredict = async () => {
        setError('');
        setPredictionResult(null);
        try {
            const response = await fetch('https://ai.ninjabakers.com/predict_for_next_period', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ item_name: itemName })
            });

            if (!response.ok) {
                const errData = await response.json();
                setError(errData.error || 'Prediction failed');
                return;
            }

            const data = await response.json();
            setPredictionResult(data.predicted_quantity);
        } catch (err) {
            setError('Error calling the prediction API');
            console.error(err);
        }
    };

    const handleMultiDayPrediction = async () => {
        setMultiPrediction([]);
        setError('');

        try {
            const response = await fetch('https://ai.ninjabakers.com/predict_for_next_days', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    item_name: selectedItem,
                    num_days: selectedDays,
                    start_day_of_week: startDay
                })
            });

            if (!response.ok) {
                const errData = await response.json();
                setError(errData.error || 'Multi-day prediction failed');
                return;
            }

            const data = await response.json();
            setMultiPrediction(data.predictions || []);
        } catch (err) {
            setError('Error calling the multi-day prediction API');
            console.error(err);
        }
    };

    return (
        <div className="mt-20 p-4 flex flex-col gap-12 md:flex-row">
            {/* LEFT: Single Day Prediction */}
            <div className="md:w-1/3">
                <h2 className="text-xl font-bold mb-4">Single Item Prediction</h2>
                <input
                    type="text"
                    value={itemName}
                    onChange={(e) => setItemName(e.target.value)}
                    className="border border-gray-300 p-2 rounded w-full mb-2"
                    placeholder="Enter item name"
                />
                <button
                    onClick={handlePredict}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                    Predict
                </button>

                {error && <div className="text-red-600 mt-3">{error}</div>}

                {predictionResult !== null && (
                    <div className="mt-4 text-green-700 font-semibold">
                        Predicted Quantity: {predictionResult.toFixed(2)}
                    </div>
                )}
            </div>

            {/* MIDDLE: Multi-day Prediction */}
            <div className="md:w-1/3">
                <h2 className="text-xl font-bold mb-4">Multi-Day Prediction</h2>

                <label className="block mb-1 font-semibold">Item</label>
                <select
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    className="w-full p-2 mb-3 border border-gray-300 rounded"
                >
                    {itemOptions.map((item, idx) => (
                        <option key={idx} value={item}>{item}</option>
                    ))}
                </select>

                <label className="block mb-1 font-semibold">Start Day</label>
                <select
                    value={startDay}
                    onChange={(e) => setStartDay(e.target.value)}
                    className="w-full p-2 mb-3 border border-gray-300 rounded"
                >
                    {weekdays.map((day) => (
                        <option key={day} value={day}>{day}</option>
                    ))}
                </select>

                <label className="block mb-1 font-semibold">Number of Days</label>
                <select
                    value={selectedDays}
                    onChange={(e) => setSelectedDays(Number(e.target.value))}
                    className="w-full p-2 mb-3 border border-gray-300 rounded"
                >
                    <option value={5}>5 Days</option>
                    <option value={7}>7 Days</option>
                </select>

                <button
                    onClick={handleMultiDayPrediction}
                    className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
                >
                    Predict Next {selectedDays} Days
                </button>

                {multiPrediction.length > 0 && (
                    <div className="mt-4">
                        <h3 className="font-bold text-lg mb-2">Forecast:</h3>
                        <ul className="space-y-2">
                            {multiPrediction.map((item, idx) => (
                                <li key={idx} className="p-2 border rounded">
                                    <strong>{item.day_of_week}</strong>: {item.predicted_quantity.toFixed(2)}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {/* RIGHT: High Waste Items */}
            <div className="md:w-1/3">
                <h2 className="text-xl font-bold mb-4">High Wastage Products</h2>
                {highWasteItems.length === 0 ? (
                    <p className="text-gray-600">Loading high-waste items...</p>
                ) : (
                    <ul className="space-y-2">
                        {highWasteItems.map((item, index) => (
                            <li key={index} className="border p-2 rounded">
                                <p className="font-semibold">{item.item_name}</p>
                                <p>Avg Leftover: {item.avg_leftover.toFixed(2)}</p>
                                <p>Predicted Quantity: {item.predicted_quantity.toFixed(2)}</p>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default Prediction;
